//Services
import { gen2Request } from 'src/services/gen_2_http_reqs';
//Types
import type { Device } from 'src/types/Device';
import type { SettingRequest } from 'src/types/requests/settings/setting';

/**
 * Disables user automations for a Cury device.
 *
 * This function sends a configuration request to disable all user-defined automations
 * on the specified Cury device. This is typically used when there are issues with
 * vial validation or when manual control is needed.
 *
 * @param {any} device - The Cury device object containing device information and connection details
 *
 * @returns {Promise<any>} A promise that resolves to the response from the device configuration request
 *
 * @example
 * // Disable automations for a Cury device
 * const result = await disableUserAutomations(curyDevice);
 * if (result.isok) {
 *   console.log('Automations disabled successfully');
 * }
 *
 */
export const disableUserAutomations: (device: Device) => Promise<SettingRequest> = async (
	device: Device,
) => {
	return gen2Request(device, 'Cury.SetConfig', {
		id: 0,
		config: { automations: { enabled: false } },
	});
};
